<template>
	<div>
		<compWrapper title="基础信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<compWrapper title="费用明细" theme="primary">
			<compTablelist class="margin-layout" :columns="getColumns" v-bind="getCostTableProps"></compTablelist>
			<vButton slot="footer" @click="cancel">返回</vButton>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>

import { HttpExtraService, HttpMaterialCost, HttpQueryBillDetail, HttpWarehouseCost, HttpDistribution, HttpStorageCost, HttpAdjustAccountCost } from '@/service/costbilling';
import { mapGetters } from 'vuex';
import mixin from '../../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import('@components/templates/log'),
		compTablelist: () => import("@components/templates/tablelist"),
	},
	data() {
		return {
			loading: false,
			formData: {},
			datalist: [],
			type: this.$route.query.type,
			id: this.$route.query.id,
			parentId: this.$route.query.parentId,
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList']),
		//费用详情列表属性
		getCostTableProps() {
			const typeMap = {
				1: HttpWarehouseCost,
				2: HttpDistribution,
				3: HttpExtraService,
				4: HttpStorageCost,
				5: HttpMaterialCost,
				6: HttpAdjustAccountCost,
			}
			return {
				initFormData: {
					'search[EQ_billId]': this.parentId,
				},
				startUp: true,
				ajaxRequest: typeMap[this.type],
			};
		},
		getBase() {
			return [
				{
					label: '账单编号',
					key: 'billNo',
				}, {
					label: '状态',
					key: 'billStatus',
					valueText: this.formData.billStatus == 1 ? '已确认' : '已创建'
				}, {
					label: '组织',
					key: 'organizationName',
					// options: this.getBillcusorgList
				},
				// {
				// 	label: '仓库',
				// 	key: 'orgWarehouseCode',
				// 	// options: this.getBillcusWareList
				// },
				{
					label: '总费用',
					// key: 'totalCost',
					valueText: this.formData.totalCost + ' ' + this.formData.currency
				}, {
					label: '月份',
					key: 'billingDate',
				}, {
					label: '费用类型',
					key: 'costType',
					options: this.getCostType
				},

			]
		},
		//按照类型获取 columns
		getColumns() {
			const typeMap = {
				1: 'getWarehouseColumns',
				2: 'getDistributionColumns',
				3: 'getServiceColumns',
				4: 'getStorageColumns',
				5: 'getMaterialColumns',
				6: 'getAccountColumns',
			};
			return this[typeMap[this.type]]
		},
		//业务类型
		getBusinessType() {
			return [{
				label: "中转费用",
				value: '1'
			}, {
				label: "一般入库",
				value: '2'
			}, {
				label: "销售订单",
				value: '3'
			}, {
				label: "仓储",
				value: '4'
			}, {
				label: "其他",
				value: '5'
			}, {
				label: "调拨",
				value: '6'
			}, {
				label: "退货",
				value: '7'
			}, {
				label: "All",
				value: '10'
			}, {
				label: "无来源入库",
				value: '11'
			},{
				label: "销毁单",
				value: '20'
			}, {
				label: '仓库',
				key: 'orgWarehouseCode',
			}]
		},
		//仓库作业费
		getWarehouseColumns() {
			return [
				{
					title: "业务类型",
					key: 'businessType',
					render: (h, { row }) => {
						const businessType = row.businessType
						const { label } = this.getBusinessType.find(function (item) {
							return item.value == businessType
						}) || {};
						return label || '--'
					}
				},
                {
                    title: '仓库',
                	key: 'orgWarehouseCode',
                	// options: this.getBillcusWareList
                },
				{
					title: "一级分类",
					key: 'firstBillingCategoryName'
				},
				{
					title: "二级分类",
					key: 'secondBillingCategoryName'
				},
				{
					title: "三级分类",
					key: 'thirdBillingCategoryName'
				},
				{
					title: "费率",
					key: 'rate'
				},
				{
					title: "数量",
					key: 'count'
				},
				{
					title: "总费用",
					key: 'cost'
				},
				{
					title: "计费单号",
					key: 'relOrderNo'
				},
				{
					title: "识别号",
					key: 'sourceNo'
				},
				{
					title: "集装箱号",
					key: 'containerNo'
				},
				{
					title: "SKU",
					key: 'relSku'
				},
				{
					title: "项目",
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: "更新时间",
					key: 'updatedAt'
				}
			]
		},
		// 配送费
		getDistributionColumns() {
			return [
			    {
					title: "Tracking",
					key: '关联单号'
				},
				{
					title: "承运商服务",
					key: 'carrierServiceCode'
				},
				{
					title: "收费项",
					key: 'costName'
				},
				{
					title: "收费金额",
					key: 'cost'
				},
				{
					title: "币种",
					key: 'currency'
				},
				{
					title: "项目",
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: "关联单号",
					key: 'sourceNo'
				},
				{
					title: "收费时间",
					key: 'createdAt'
				}
			]
		},
		// 仓储
		getStorageColumns() {
			return [
                {
                    title: '仓库',
                    key: 'orgWarehouseCode',
                    // options: this.getBillcusWareList
                },
				{
					title: "SKU",
					key: 'sku'
				},
				{
					title: "库存类型",
					// key: 'inventoryType',
					render: (h, { row }) => {
						switch (row.inventoryType) {
							case 'CAN_SALE': return '可售库存'; break;
							case 'NO_SALE': return '不可售库存'; break;
						}
					}
				},
				{
					title: "批次号",
					key: 'batchNo'
				},
				{
					title: "存储天数",
					key: 'storageDays'
				},
				{
					title: "库存",
					key: 'stock'
				},
				{
					title: "计费量",
                    key: 'billNum',
                    render: (h, { row }) => {
                        let unitArr = {
                            'BILL_UNIT_CUBIC_METER': '立方米',
                            'BILL_UNIT_CUBIC_FOOT': '立方英尺'
                        }
                        return (
                            <div>
                                {row.billNum} * {unitArr[row.unit]}
                            </div>
                        )
                    }
				},
				{
					title: "费率",
					key: 'rate'
				},
				{
					title: "计费系数",
					key: 'modulus'
				},
				{
					title: "总费用",
					key: 'totalCost'
				},
				{
					title: "币种",
					key: 'currency'
				},
				// {
				// 	title: "长(cm)",
				// 	key: 'length'
				// },
				// {
				// 	title: "宽(cm)",
				// 	key: 'width'
				// },
				// {
				// 	title: "高(cm)",
				// 	key: 'height'
				// },
				{
					title: "尺寸(cm*cm*cm)",
					key: "length",
					render(h, { row }) {
						return `${row.length} * ${row.width} * ${row.height}`
					}
				},
				{
					title: "项目",
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: "快照日期",
					key: 'snapshotAt'
				},
				{
					title: "更新时间",
					key: 'updatedAt'
				}
			]
		},
		// 调账
		getAccountColumns() {
			return [
				{
					title: "费用类型",
					render: (h, { row }) => {
						const billingType = row.billingType
						const { label } = this.getCostType.find(function (item) {
							return item.value == billingType
						}) || {};
						return label || '--'
					}
				},
				{
					title: "计费单号",
					key: 'billingOrderNo'
				},
				{
					title: "调账类型",
					// key:'type'
					render: (h, { row }) => {
						return row.type == 1 ? '调账返还' : '调账扣减'
					}
				},
				{
					title: "调账金额",
					key: 'amount'
				},
				{
					title: "币种",
					key: 'currency'
				},
				{
					title: "调账说明",
					key: 'remark'
				},
				{
					title: "创建人",
					key: 'createdName'
				},
				{
					title: "创建时间",
					key: 'createdAt'
				}
			]
		},
		// 查看增值服务费
		getServiceColumns() {
			return [
                {
                    title: '仓库',
                    key: 'orgWarehouseCode',
                    // options: this.getBillcusWareList
                },
				{
					title: '业务类型',
					key: 'businessType',
					render: (h, { row }) => {
						const businessType = row.businessType
						const { label } = this.getBusinessType.find(function (item) {
							return item.value == businessType
						}) || {};
						return label || '--'
					}
				}, {
					title: '事务项',
					key: 'transactionCode'
				}, {
					title: '费率',
					key: 'baseRate'
				}, {
					title: '数量',
					key: 'qty'
				}, {
					title: '总费用',
					key: 'totalCost'
				}, {
					title: '币种',
					key: 'currency'
				}, {
					title: '计费单号',
					key: 'orderNo'
				}, {
					title: '识别号',
					key: 'sourceNo'
				}, {
					title: 'SKU',
					key: 'sku'
				}, {
					title: '项目',
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				}, {
					title: '更新时间',
					key: 'updatedAt'
				}
			]
		},
		//查看包材计费单
		getMaterialColumns() {
			return [
                {
                    title: '仓库',
                    key: 'warehouseCode',
                    // options: this.getBillcusWareList
                },
			    {
				title: "包材",
				key: 'materialName'
			}, {
				title: "费率",
				key: 'baseRate'
			}, {
				title: "数量",
				key: 'qty'
			}, {
				title: "总费用",
				key: 'cost'
			}, {
				title: "币种",
				key: 'currency'
			}, {
				title: "计费单号",
				key: 'orderNo'
			}, {
				title: "Tracking No.",
				key: 'trackingNo'
			}, {
				title: "项目",
				key: 'lineId',
				render: (h, { row }) => {
					const { label = '' } = this.getCusproductList.find(function (item) {
						return item.value == row.lineId
					}) || {};
					return label;
				}
			}, {
				title: "更新时间",
				key: 'updatedAt'
			}
			]
		},
	},
	methods: {
		// getCostDetail() {
		// 	const typeMap = {
		// 		// 1: 'getWarehouseDetail',
		// 		3: 'getServiceDetail',
		// 		4: 'getStorageDetail',
		// 		5: 'getMaterialDetail',
		// 		// 6: 'getAccountDetail',
		// 	};
		// 	const ajax = typeMap[this.type];
		// 	if (ajax) this[ajax]();
		// },
		//仓库作业费
		// getWarehouseDetail() {
		// 	this.loading = true;
		// 	HttpWarehouseCost({ 'search[EQ_billId]': this.parentId,page:1,rows:1000 }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data.content;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//仓储
		// getStorageDetail() {
		// 	this.loading = true;
		// 	HttpStorageCost({ 'billId': this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		// //增值服务
		// getServiceDetail() {
		// 	this.loading = true;
		// 	HttpExtraService({ billId: this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		// //包材
		// getMaterialDetail() {
		// 	this.loading = true;
		// 	HttpMaterialCost({ billId: this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//调账
		// getAccountDetail() {
		// 	this.loading = true;
		// 	HttpAdjustAccountCost({ 'search[EQ_billId]': this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data.content
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//账单明细请求头部详情页
		getDetail() {
			// this.loading = true;
			// this.getCostDetail();
			HttpQueryBillDetail({ id: this.id }).then(res => {
				this.formData = res.data;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		cancel() {
			this.$router.push({
				name: this.$route.name.slice(0, -1),
				query: {
					id: this.parentId
				}
			})
		},
	}
};
</script>
